import Vue from 'vue'
import VueRouter from 'vue-router'

import startseite from '../components/start.vue'
import meetingExtern from '../components/meeting.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path:'/meetingExtern/:raum', component:meetingExtern},
    { path:'/start', component:startseite},
    { path:'/', redirect: '/start'},
    { path:'/login', beforeEnter(to, from, next) {
      // Put the full page URL including the protocol http(s) below
      window.location.replace("https://account.archi-app.de/login")
  }
},
  ]
})

export default router
